/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveCreateRequestSchema } from "./reserveCreateRequestSchema.ts";
import { reserveSchema } from "./reserveSchema.ts";

export const orgUnitReserveCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveCreateStatus201Schema = reserveSchema;

export const orgUnitReserveCreateResponseSchema = orgUnitReserveCreateStatus201Schema;

export const orgUnitReserveCreateDataSchemaJson = reserveCreateRequestSchema;

export const orgUnitReserveCreateDataSchemaXml = reserveCreateRequestSchema;

export const orgUnitReserveCreateDataSchema = z.union([orgUnitReserveCreateDataSchemaJson, orgUnitReserveCreateDataSchemaXml]);
